import 'core-js/features/symbol';
import 'core-js/features/promise';
import 'core-js/features/object';

export default true;
